module.exports = __webpack_public_path__ + "static/media/monika.4fc47af4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/monika.webp
// module id = 298
// module chunks = 0